import { render } from "./dialog-confirm.vue?vue&type=template&id=054366a0&scoped=true&ts=true"
import script from "./dialog-confirm.vue?vue&type=script&lang=ts"
export * from "./dialog-confirm.vue?vue&type=script&lang=ts"

import "./dialog-confirm.vue?vue&type=style&index=0&id=054366a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054366a0"]])

export default __exports__